export default __webpack_public_path__ + "static/media/signInCn.1a3c63c2.jpg";